import React from 'react';
import classnames from 'classnames';

import styles from './index.module.css';

interface SectionTitleProperty {
	chName: string;
	enName: string;
	className?: string;
}

const SectionTitle: React.FC<SectionTitleProperty> = ({ chName, enName, className }) => (
	<div className={classnames(styles.sectionTitle, className)}>
		<h3 className={styles.chName}>\ {enName} /</h3>
		<h1 className={styles.chName}>{chName}</h1>
	</div>
);

export default SectionTitle;
